import { User } from "firebase/auth";
import { apiFetch } from "./client";
import { ThemeId, themeIdToDbTheme, dbThemeToThemeId } from "../themes";

export interface DbUser {
  id: string;
  firebaseId: string;
  email: string;
  displayName: string;
  role: "USER" | "ADMIN";
  theme: "LIGHT" | "DARK" | "SYSTEM";
  banned: boolean;
  emailVerified?: boolean;
  createdAt: string;
}

export interface UserStats {
  victoriesCount: number;
  topThreeCount: number;
  completedLeaguesCount: number;
  activeLeaguesCount: number;
  winRate: number;
  topThreeRate: number;
}

export function fetchMe(user: User): Promise<DbUser> {
  return apiFetch(user, "/users/me");
}

export function fetchMyStats(user: User): Promise<UserStats> {
  return apiFetch(user, "/users/me/stats");
}

export function patchDisplayName(user: User, displayName: string): Promise<DbUser> {
  return apiFetch(user, "/users/me", {
    method: "PATCH",
    body: JSON.stringify({ displayName }),
  });
}

export function patchTheme(user: User, themeId: ThemeId): Promise<DbUser> {
  return apiFetch(user, "/users/me", {
    method: "PATCH",
    body: JSON.stringify({ theme: themeIdToDbTheme(themeId) }),
  });
}

export function syncUser(user: User): Promise<DbUser> {
  return apiFetch(user, "/users/sync", {
    method: "POST",
    body: JSON.stringify({
      email: user.email,
      name: user.displayName,
      displayName: user.displayName,
    }),
  });
}

// Re-export helpers so callers don't need to import themes directly
export { dbThemeToThemeId };
